var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lives-display"},_vm._l((_vm.lives),function(index){return _c('img',{key:index,staticClass:"dummy-image",attrs:{"src":_vm.dummyImage}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }